import { combineEpics, ofType } from 'redux-observable'
import { of } from 'rxjs'
import { catchError, map, mergeMap, takeUntil } from 'rxjs/operators'

import { autoSyncDisableError, autoSyncDisableSuccess } from './actions'
import { AUTO_SYNC_DISABLE_ASYNC } from './constants'

const disableAutoSyncEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(AUTO_SYNC_DISABLE_ASYNC.INITIATE),
    mergeMap(() =>
      api.mailboxes.disableAutoSync(state$.value.partnerOptions.selectedCompany?.value).pipe(
        map(() => autoSyncDisableSuccess()),
        catchError((error) => of(epicsErrorHandler(autoSyncDisableError, error))),
        takeUntil(action$.pipe(ofType(AUTO_SYNC_DISABLE_ASYNC.CANCEL)))
      )
    )
  )

export default combineEpics(disableAutoSyncEpic)
